
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AppHome.css";

const BASE_URL = "https://gym-invoice-back.onrender.com";

function LoginPage() {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {

    e.preventDefault();

    setMessage("");
    setMessageType("");

    // =====================================================
    // VALIDATE INPUT
    // =====================================================

    if (!username.trim() || !password.trim()) {

      setMessage("⚠️ Please enter username and password.");
      setMessageType("error");

      return;
    }

    try {

      // =====================================================
      // LOGIN API
      // =====================================================

      const response = await fetch(
        `${BASE_URL}/api/users/login`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
            username: username.trim(),
            password: password
          })
        }
      );

      const data = await response.json();

      // =====================================================
      // LOGIN FAILED
      // =====================================================

      if (!response.ok) {

        setMessage(
          typeof data === "string"
            ? data
            : data.message || "❌ Invalid username or password."
        );

        setMessageType("error");

        return;
      }

      // =====================================================
      // CLEAR OLD LOGIN DATA
      // =====================================================

      sessionStorage.clear();

      // =====================================================
      // SAVE USER INFORMATION
      // =====================================================

      sessionStorage.setItem(
        "userId",
        data.id || ""
      );

      sessionStorage.setItem(
        "username",
        data.username || ""
      );

      sessionStorage.setItem(
        "name",
        data.assistantName || data.name || ""
      );

      // IMPORTANT:
      // ProtectedRoute uses "userRole"
      sessionStorage.setItem(
        "userRole",
        data.role || ""
      );

      // =====================================================
      // SAVE LOGGED-IN USER BRANCH
      // =====================================================

      sessionStorage.setItem(
        "branchId",
        data.branchId || ""
      );

      sessionStorage.setItem(
        "branchCode",
        data.branchCode || ""
      );

      sessionStorage.setItem(
        "branchName",
        data.branchName || ""
      );

      // Save token if backend provides one
      if (data.token) {

        sessionStorage.setItem(
          "token",
          data.token
        );
      }

      // =====================================================
      // LOGIN SUCCESS
      // =====================================================

      setMessage("✅ Login successful!");
      setMessageType("success");

      // =====================================================
      // ADMIN LOGIN
      // =====================================================

      if (data.role === "ADMIN") {

        setTimeout(() => {
          navigate("/dashboard-admin");
        }, 300);

        return;
      }

      // =====================================================
      // USER LOGIN
      // =====================================================

      if (data.role === "USER") {

        setTimeout(() => {
          navigate("/dashboard");
        }, 300);

        return;
      }

      // =====================================================
      // UNKNOWN ROLE
      // =====================================================

      sessionStorage.clear();

      setMessage(
        "❌ Your account does not have a valid role."
      );

      setMessageType("error");

    } catch (error) {

      console.error("Login error:", error);

      setMessage(
        "❌ Unable to connect to server."
      );

      setMessageType("error");
    }
  };


  return (

    <div className="login-container2">

      <div className="login-container">

        <img
          src={`${process.env.PUBLIC_URL}/Images/logo.jpeg`}
          alt="Logo"
          className="login-logo"
        />

        <form
          className="login-form"
          onSubmit={handleLogin}
        >

          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) =>
              setUsername(e.target.value)
            }
            autoComplete="username"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) =>
              setPassword(e.target.value)
            }
            autoComplete="current-password"
          />

          <button type="submit">
            Login
          </button>

        </form>

        {message && (

          <p
            className={`message ${
              messageType === "success"
                ? "success"
                : "error"
            }`}
          >
            {message}
          </p>

        )}

      </div>

    </div>
  );
}

export default LoginPage;

